import { http, HttpResponse } from 'msw';

import { KidValidationPayload } from '../../api/KidValidation';

export const validateKidHandlers = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/validation/kid', async ({ request }) => {
        const payload: KidValidationPayload = (await request.json()) as KidValidationPayload;

        if (payload.KIDNumber && payload.KIDNumber.length < 9) {
            return HttpResponse.json({
                status: 'INVALID',
                ruleParameterName: 'string',
                sourceParameterName: 'string',
                validationMessageKey: 'string',
            });
        }

        return HttpResponse.json({
            status: 'SUCCESS',
            ruleParameterName: 'string',
            sourceParameterName: 'string',
            validationMessageKey: 'string',
        });
    }),
];
